import { CART_MODULE } from "@/api_framework/api_config";
import { ICartGiftCard } from "@/api_framework/api_modals/Cart";

import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

interface IAPIreturnProps {
  status: boolean;
  data: ICartGiftCard[] | null;
}

AxiosCurlirize(axios, () => {});

export const useCartGiftsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (cart_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: IAPIreturnProps = await axios
          .get(`${CART_MODULE?.CART_GIFTS?.baseURL}/${cart_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartGiftCard[]>) => {
            if (Array.isArray(res.data)) {
              return { status: true, data: res.data };
            } else {
              return { status: false, data: [] };
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            sendCurl(e.config?.["curlCommand"]);

            return { status: false, data: null };
          });

        return response;
      } catch (e: any) {
        toast.error(e.message);
      }
    },
    [dispatch],
  );

  return execute;
};
